import { React } from "react";

import Footer from "../../components/Footer";

import PopupModal from "../popupModal/PopupModal";
import { SocialIcon } from "react-social-icons";
import NyliaButton from "../nyliaButton/NyliaButton.js";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import yocelynSm from "../../assets/nbc/headshots/JPEG-300/Yocelyn.png";
import yocelynMd from "../../assets/nbc/headshots/JPEG-768/Yocelyn.png";
import yocelynLg from "../../assets/nbc/headshots/JPEG-1280/Yocelyn.png";
import yocelynXL from "../../assets/nbc/headshots/JPEG-2000/Yocelyn.png";
import anaCristinaSm from "../../assets/nbc/headshots/JPEG-300/AnaC.png";
import anaCristinaMd from "../../assets/nbc/headshots/JPEG-768/AnaC.png";
import anaCristinaLg from "../../assets/nbc/headshots/JPEG-1280/AnaC.png";
import anaCristinaXL from "../../assets/nbc/headshots/JPEG-2000/AnaC.png";
import sophieSm from "../../assets/nbc/headshots/JPEG-300/Sophie.png";
import sophieMd from "../../assets/nbc/headshots/JPEG-768/Sophie.png";
import sophieLg from "../../assets/nbc/headshots/JPEG-1280/Sophie.png";
import sophieXL from "../../assets/nbc/headshots/JPEG-2000/Sophie.png";
import gracielaSm from "../../assets/nbc/headshots/JPEG-300/Graciela.png";
import gracielaMd from "../../assets/nbc/headshots/JPEG-768/Graciela.png";
import gracielaLg from "../../assets/nbc/headshots/JPEG-1280/Graciela.png";
import gracielaXL from "../../assets/nbc/headshots/JPEG-2000/Graciela.png";

import camilaSm from "../../assets/nbc/headshots/JPEG-300/Camila.png";
import camilaMd from "../../assets/nbc/headshots/JPEG-768/Camila.png";
import camilaLg from "../../assets/nbc/headshots/JPEG-1280/Camila.png";
import camilaXL from "../../assets/nbc/headshots/JPEG-2000/Camila.png";
import anahidSm from "../../assets/nbc/headshots/JPEG-300/Anahid.png";
import anahidMd from "../../assets/nbc/headshots/JPEG-768/Anahid.png";
import anahidLg from "../../assets/nbc/headshots/JPEG-1280/Anahid.png";
import anahidXL from "../../assets/nbc/headshots/JPEG-2000/Anahid.png";
import beckSm from "../../assets/nbc/headshots/JPEG-300/Beck.png";
import beckMd from "../../assets/nbc/headshots/JPEG-768/Beck.png";
import beckLg from "../../assets/nbc/headshots/JPEG-1280/Beck.png";
import beckXL from "../../assets/nbc/headshots/JPEG-2000/Beck.png";
import luisaSm from "../../assets/nbc/headshots/JPEG-300/LuisaC.png";
import luisaMd from "../../assets/nbc/headshots/JPEG-768/LuisaC.png";
import luisaLg from "../../assets/nbc/headshots/JPEG-1280/LuisaC.png";
import luisaXL from "../../assets/nbc/headshots/JPEG-2000/LuisaC.png";
import valeriaSm from "../../assets/nbc/headshots/JPEG-300/Valeria.png";
import valeriaMd from "../../assets/nbc/headshots/JPEG-768/Valeria.png";
import valeriaLg from "../../assets/nbc/headshots/JPEG-1280/Valeria.png";
import valeriaXL from "../../assets/nbc/headshots/JPEG-2000/Valeria.png";
import naraeSm from "../../assets/nbc/headshots/JPEG-300/Narae.png";
import naraeMd from "../../assets/nbc/headshots/JPEG-768/Narae.png";
import naraeLg from "../../assets/nbc/headshots/JPEG-1280/Narae.png";
import naraeXL from "../../assets/nbc/headshots/JPEG-2000/Narae.png";
import audreySm from "../../assets/nbc/headshots/JPEG-300/Audrey.png";
import audreyMd from "../../assets/nbc/headshots/JPEG-768/Audrey.png";
import audreyLg from "../../assets/nbc/headshots/JPEG-1280/Audrey.png";
import audreyXL from "../../assets/nbc/headshots/JPEG-2000/Audrey.png";
import christinaSm from "../../assets/nbc/headshots/JPEG-300/Christina.png";
import christinaMd from "../../assets/nbc/headshots/JPEG-768/Christina.png";
import christinaLg from "../../assets/nbc/headshots/JPEG-1280/Christina.png";
import christinaXL from "../../assets/nbc/headshots/JPEG-2000/Christina.png";
import logoXL from "../../assets/logos/Nylia Company Logos/2-cropped.png";

import "./CompanyDancers.css";

function CompanyDancers() {
  const goToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView(false);
  };

  // const traineeInfo = [
  //   {
  //     name: "Valeria Villanueva",
  //     title: "Corps de Ballet",
  //     imgSm: valeriaSm,
  //     imgMd: valeriaMd,
  //     imgLg: valeriaLg,
  //     imgXL: valeriaXL,
  //   },
  // ];

  const dancerInfo = [
    {
      name: "Yocelyn Salcido",
      title: "Soloist",
      imgSm: yocelynSm,
      imgMd: yocelynMd,
      imgLg: yocelynLg,
      imgXL: yocelynXL,
    },
    {
      name: "Anahid Aguirre",
      title: "Soloist",
      imgSm: anahidSm,
      imgMd: anahidMd,
      imgLg: anahidLg,
      imgXL: anahidXL,
    },
    {
      name: "Beck Cuellar",
      title: "Corps de Ballet",
      imgSm: beckSm,
      imgMd: beckMd,
      imgLg: beckLg,
      imgXL: beckXL,
    },
    {
      name: "Luisa Cuellar",
      title: "Corps de Ballet",
      imgSm: luisaSm,
      imgMd: luisaMd,
      imgLg: luisaLg,
      imgXL: luisaXL,
    },
    {
      name: "Narae Kim",
      title: "Corps de Ballet",
      imgSm: naraeSm,
      imgMd: naraeMd,
      imgLg: naraeLg,
      imgXL: naraeXL,
    },
    {
      name: "Valeria Villanueva",
      title: "Corps de Ballet",
      imgSm: valeriaSm,
      imgMd: valeriaMd,
      imgLg: valeriaLg,
      imgXL: valeriaXL,
    },
    {
      name: "Ana Cristina Muñetones",
      title: "Apprentice",
      imgSm: anaCristinaSm,
      imgMd: anaCristinaMd,
      imgLg: anaCristinaLg,
      imgXL: anaCristinaXL,
    },
    {
      name: "Audrey Juarez",
      title: "Apprentice",
      imgSm: audreySm,
      imgMd: audreyMd,
      imgLg: audreyLg,
      imgXL: audreyXL,
    },
    {
      name: "Camila Montelongo",
      title: "Apprentice",
      imgSm: camilaSm,
      imgMd: camilaMd,
      imgLg: camilaLg,
      imgXL: camilaXL,
    },
    {
      name: "Christina Acosta",
      title: "Apprentice",
      imgSm: christinaSm,
      imgMd: christinaMd,
      imgLg: christinaLg,
      imgXL: christinaXL,
    },
    {
      name: "Graciela Acosta",
      title: "Apprentice",
      imgSm: gracielaSm,
      imgMd: gracielaMd,
      imgLg: gracielaLg,
      imgXL: gracielaXL,
    },
    {
      name: "Sophie Piatt",
      title: "Apprentice",
      imgSm: sophieSm,
      imgMd: sophieMd,
      imgLg: sophieLg,
      imgXL: sophieXL,
    },
  ];

  function dancersCards(dancersInformation) {
    return (
      <Row xs={1} sm={2} md={3} lg={4} className="g-4">
        {dancersInformation.map((item, idx) => (
          <Col>
            <Card>
              <Card.Img
                variant="top"
                src={item.imgSm}
                srcSet={`${item.imgSm} 300w, ${item.imgMd} 768w, ${item.imgLg} 1280w, ${item.imgXL} 2000w`}
              />
              <Card.Body>
                <Card.Title>{item.name}</Card.Title>
                <Card.Text>
                  <i>{item.title}</i>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    );
  }

  return (
    <div class="companydancers-container">
      <div className="main-img-bkg" id="mission-section">
        <div className="main-title">
          <h1>COMPANY DANCERS</h1>
        </div>
        <div className="companydancers-main-box">
          <p>
            <br />
            Nylia Ballet Company inspires a vibrant community through ballet's
            transformative power. Our diverse dancers balance full-time jobs
            with professional training, sharing the beauty of dance and
            enriching the El Paso Borderland community's cultural heritage. With
            a dedication to artistic integrity, social responsibility, and
            collaboration, Nylia Ballet Company enriches the lives of our
            audience members, performers, and community alike. Together we
            create moments of beauty, inspiration, and joy that resonate far
            beyond the stage.
          </p>
          <img
            src={logoXL}
            alt="Camila Hellmuth posing for Nylia Ballet Academy Performance"
            id="companydancers-logo"
          />
        </div>
      </div>
      <div className="main-img-bkg" id="nbc-section">
        <div className="companydancers-main-box" id="companydancers">
          <h1 id="highlightTitle">NYLIA BALLET COMPANY</h1>
          <h2>
            <i>Company Dancers</i>
          </h2>
          <div>{dancersCards(dancerInfo)}</div>
          <br></br>

          <br></br>
          {/* <h1 id="highlightTitle">NYLIA BALLET COMPANY</h1>
          <h2>
            <i>Company Trainees</i>
          </h2>
          <div>{dancersCards(traineeInfo)}</div>
          <br></br> */}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default CompanyDancers;
